import { Component, Input, OnInit } from '@angular/core';
import { NextcloudFile } from '../../../classes';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-nextcloud-file-preview',
  templateUrl: './nextcloud-file-preview.component.html',
  styleUrls: ['./nextcloud-file-preview.component.css']
})
export class NextcloudFilePreviewComponent implements OnInit {

  name: string;
  icon: string;

  @Input() file: NextcloudFile;

  constructor(
    private _fileService: FileService
  ) { }

  ngOnInit(): void {
    this.updateValues();
  }

  updateValues(){
    this.name = decodeURIComponent(FileService.getFileName(this.file.href));
    this.icon = FileService.getFileType(this.file.type);
  }

}
